import { render, staticRenderFns } from "./button-nav.vue?vue&type=template&id=2f5f1e8c"
import script from "./button-nav.vue?vue&type=script&lang=js"
export * from "./button-nav.vue?vue&type=script&lang=js"
import style0 from "./button-nav.vue?vue&type=style&index=0&id=2f5f1e8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports